/**
 * Generated by orval v7.1.1 🍺
 * Do not edit manually.
 * AOS WWW API
 * AOS WWW API
 * OpenAPI spec version: 1.0.0
 */
import axios from 'axios'
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
import useSwr from 'swr'
import type {
  Key,
  SWRConfiguration
} from 'swr'
import useSWRMutation from 'swr/mutation'
import type {
  SWRMutationConfiguration
} from 'swr/mutation'
import {
  faker
} from '@faker-js/faker'
import {
  HttpResponse,
  delay,
  http
} from 'msw'

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;

export type GetRedialParams = {
/**
 * created
 */
created?: string;
/**
 * date_after
 */
date_after?: string;
/**
 * date_before
 */
date_before?: string;
};

export type UpdateTaskStatus200 = { [key: string]: unknown };

export type UpdateTaskStatusBodyStatus = typeof UpdateTaskStatusBodyStatus[keyof typeof UpdateTaskStatusBodyStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateTaskStatusBodyStatus = {
  canceled: 'canceled',
} as const;

export type UpdateTaskStatusBody = {
  status?: UpdateTaskStatusBodyStatus;
  task_sid?: string;
};

export type CreateTaskBody = {
  deviceId?: string;
  facilityId?: string;
  guestConnectionStartTime?: number;
  language?: string;
  requirement?: string;
};

/**
 * @nullable
 */
export type ReceptionCallHistoryReceiverStatus = typeof ReceptionCallHistoryReceiverStatus[keyof typeof ReceptionCallHistoryReceiverStatus] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReceptionCallHistoryReceiverStatus = {
  NUMBER_0: 0,
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
  NUMBER_5: 5,
} as const;

/**
 * @nullable
 */
export type ReceptionCallHistoryCallerStatus = typeof ReceptionCallHistoryCallerStatus[keyof typeof ReceptionCallHistoryCallerStatus] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReceptionCallHistoryCallerStatus = {
  NUMBER_0: 0,
  NUMBER_1: 1,
  NUMBER_2: 2,
  NUMBER_3: 3,
  NUMBER_4: 4,
  NUMBER_5: 5,
} as const;

export type ReceptionCallHistoryCallType = typeof ReceptionCallHistoryCallType[keyof typeof ReceptionCallHistoryCallType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReceptionCallHistoryCallType = {
  call_from_device: 'call_from_device',
  redial_from_reception: 'redial_from_reception',
} as const;

export interface ReceptionCallHistory {
  readonly call_type?: ReceptionCallHistoryCallType;
  /** @nullable */
  caller_status?: ReceptionCallHistoryCallerStatus;
  canceled?: string;
  established?: string;
  finished?: string;
  readonly meeting_id?: string;
  received?: string;
  /** @nullable */
  receiver_status?: ReceptionCallHistoryReceiverStatus;
  readonly reception_device_id?: string;
  rejected?: string;
  readonly task_sid?: string;
  timeouted?: string;
}

export interface ReceptionDevice {
  /** Bit flag for call systems. 1 is Suitebook Calls, 2 is Alex, 3 means both and Alex is preferred by the frontend. */
  automated_communication_system?: number;
  call_system?: string;
  id?: string;
  organization_slug?: string;
  /** AOS property ULID passed to Amazon Connect as hotel_id/hotelId for Alex calls. */
  property_id?: string;
  property_slug?: string;
  readonly property_translations?: ReceptionDevicePropertyTranslations;
  translations?: ReceptionDeviceTranslations;
}

export type ReceptionDeviceTranslationsJa = {
  description?: string;
  name?: string;
};

export type ReceptionDeviceTranslationsEn = {
  description?: string;
  name?: string;
};

export type ReceptionDeviceTranslations = {
  en?: ReceptionDeviceTranslationsEn;
  ja?: ReceptionDeviceTranslationsJa;
};

export type ReceptionDevicePropertyTranslationsJa = {
  name?: string;
};

export type ReceptionDevicePropertyTranslationsEn = {
  name?: string;
};

export type ReceptionDevicePropertyTranslations = {
  readonly en?: ReceptionDevicePropertyTranslationsEn;
  readonly ja?: ReceptionDevicePropertyTranslationsJa;
};

export interface MediaPlacement {
  AudioFallbackUrl?: string;
  AudioHostUrl?: string;
  EventIngestionUrl?: string;
  ScreenDataUrl?: string;
  ScreenSharingUrl?: string;
  ScreenViewingUrl?: string;
  SignalingUrl?: string;
  TurnControlUrl?: string;
}

/**
 * @nullable
 */
export type MeetingMeetingFeatures = { [key: string]: unknown } | null;

export interface Meeting {
  ExternalMeetingId?: string;
  MediaPlacement?: MediaPlacement;
  MediaRegion?: string;
  MeetingArn?: string;
  /** @nullable */
  MeetingFeatures?: MeetingMeetingFeatures;
  /** @nullable */
  MeetingHostId?: string | null;
  MeetingId?: string;
  /** @nullable */
  PrimaryMeetingId?: string | null;
  TenantIds?: string[];
}

export interface Capabilities {
  Audio?: string;
  Content?: string;
  Video?: string;
}

export interface Attendee {
  AttendeeId?: string;
  Capabilities?: Capabilities;
  ExternalUserId?: string;
  JoinToken?: string;
}

export interface AttendeeResponses {
  Attendees: Attendee[];
}

export interface MeetingResponse {
  Attendees?: Attendee[];
  deviceId?: string;
  Errors?: string[];
  guestConnectionStartTime?: number;
  language?: string;
  Meeting?: Meeting;
  propertySlug?: string;
  requirement?: string;
}

export interface TaskStatusResponse {
  result?: boolean;
}

export interface CreateTaskResponse {
  task_sid?: string;
}




  type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


  export const createTask = (
    deviceId: string,
    createTaskBody: CreateTaskBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CreateTaskResponse>> => {
    return axios.post(
      `https://www.suitebook.cloud/api/v1/receptions/${deviceId}/create-task/`,
      createTaskBody,options
    );
  }



export const getCreateTaskMutationFetcher = (deviceId: string, options?: AxiosRequestConfig) => {
  return (_: Key, { arg }: { arg: CreateTaskBody }): Promise<AxiosResponse<CreateTaskResponse>> => {
    return createTask(deviceId, arg, options);
  }
}
export const getCreateTaskMutationKey = (deviceId: string,) => [`https://www.suitebook.cloud/api/v1/receptions/${deviceId}/create-task/`] as const;

export type CreateTaskMutationResult = NonNullable<Awaited<ReturnType<typeof createTask>>>
export type CreateTaskMutationError = AxiosError<unknown>

export const useCreateTask = <TError = AxiosError<unknown>>(
  deviceId: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof createTask>>, TError, Key, CreateTaskBody, Awaited<ReturnType<typeof createTask>>> & { swrKey?: string }, axios?: AxiosRequestConfig}
) => {

  const {swr: swrOptions, axios: axiosOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getCreateTaskMutationKey(deviceId);
  const swrFn = getCreateTaskMutationFetcher(deviceId, axiosOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export const getTaskMeeting = (
    taskSid: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MeetingResponse>> => {
    return axios.get(
      `https://www.suitebook.cloud/api/v1/receptions/meeting/${taskSid}/`,options
    );
  }



export const getGetTaskMeetingKey = (taskSid: string,) => [`https://www.suitebook.cloud/api/v1/receptions/meeting/${taskSid}/`] as const;

export type GetTaskMeetingQueryResult = NonNullable<Awaited<ReturnType<typeof getTaskMeeting>>>
export type GetTaskMeetingQueryError = AxiosError<unknown>

export const useGetTaskMeeting = <TError = AxiosError<unknown>>(
  taskSid: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getTaskMeeting>>, TError> & { swrKey?: Key, enabled?: boolean }, axios?: AxiosRequestConfig }
) => {
  const {swr: swrOptions, axios: axiosOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && !!(taskSid)
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetTaskMeetingKey(taskSid) : null);
  const swrFn = () => getTaskMeeting(taskSid, axiosOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export const getReceptionDevice = (
    deviceId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ReceptionDevice>> => {
    return axios.get(
      `https://www.suitebook.cloud/api/v1/receptions/${deviceId}/`,options
    );
  }



export const getGetReceptionDeviceKey = (deviceId: string,) => [`https://www.suitebook.cloud/api/v1/receptions/${deviceId}/`] as const;

export type GetReceptionDeviceQueryResult = NonNullable<Awaited<ReturnType<typeof getReceptionDevice>>>
export type GetReceptionDeviceQueryError = AxiosError<unknown>

export const useGetReceptionDevice = <TError = AxiosError<unknown>>(
  deviceId: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getReceptionDevice>>, TError> & { swrKey?: Key, enabled?: boolean }, axios?: AxiosRequestConfig }
) => {
  const {swr: swrOptions, axios: axiosOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && !!(deviceId)
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetReceptionDeviceKey(deviceId) : null);
  const swrFn = () => getReceptionDevice(deviceId, axiosOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export const updateTaskStatus = (
    deviceId: string,
    updateTaskStatusBody: UpdateTaskStatusBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UpdateTaskStatus200>> => {
    return axios.patch(
      `https://www.suitebook.cloud/api/v1/receptions/${deviceId}/task-status/`,
      updateTaskStatusBody,options
    );
  }



export const getUpdateTaskStatusMutationFetcher = (deviceId: string, options?: AxiosRequestConfig) => {
  return (_: Key, { arg }: { arg: UpdateTaskStatusBody }): Promise<AxiosResponse<UpdateTaskStatus200>> => {
    return updateTaskStatus(deviceId, arg, options);
  }
}
export const getUpdateTaskStatusMutationKey = (deviceId: string,) => [`https://www.suitebook.cloud/api/v1/receptions/${deviceId}/task-status/`] as const;

export type UpdateTaskStatusMutationResult = NonNullable<Awaited<ReturnType<typeof updateTaskStatus>>>
export type UpdateTaskStatusMutationError = AxiosError<unknown>

export const useUpdateTaskStatus = <TError = AxiosError<unknown>>(
  deviceId: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof updateTaskStatus>>, TError, Key, UpdateTaskStatusBody, Awaited<ReturnType<typeof updateTaskStatus>>> & { swrKey?: string }, axios?: AxiosRequestConfig}
) => {

  const {swr: swrOptions, axios: axiosOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getUpdateTaskStatusMutationKey(deviceId);
  const swrFn = getUpdateTaskStatusMutationFetcher(deviceId, axiosOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export const getDeviceMeeting = (
    deviceId: string,
    meetingId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MeetingResponse>> => {
    return axios.get(
      `https://www.suitebook.cloud/api/v1/receptions/${deviceId}/meetings/${meetingId}/`,options
    );
  }



export const getGetDeviceMeetingKey = (deviceId: string,
    meetingId: string,) => [`https://www.suitebook.cloud/api/v1/receptions/${deviceId}/meetings/${meetingId}/`] as const;

export type GetDeviceMeetingQueryResult = NonNullable<Awaited<ReturnType<typeof getDeviceMeeting>>>
export type GetDeviceMeetingQueryError = AxiosError<unknown>

export const useGetDeviceMeeting = <TError = AxiosError<unknown>>(
  deviceId: string,
    meetingId: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getDeviceMeeting>>, TError> & { swrKey?: Key, enabled?: boolean }, axios?: AxiosRequestConfig }
) => {
  const {swr: swrOptions, axios: axiosOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && !!(deviceId && meetingId)
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetDeviceMeetingKey(deviceId,meetingId) : null);
  const swrFn = () => getDeviceMeeting(deviceId,meetingId, axiosOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export const getAttendees = (
    deviceId: string,
    meetingId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AttendeeResponses>> => {
    return axios.get(
      `https://www.suitebook.cloud/api/v1/receptions/${deviceId}/attendees/${meetingId}/`,options
    );
  }



export const getGetAttendeesKey = (deviceId: string,
    meetingId: string,) => [`https://www.suitebook.cloud/api/v1/receptions/${deviceId}/attendees/${meetingId}/`] as const;

export type GetAttendeesQueryResult = NonNullable<Awaited<ReturnType<typeof getAttendees>>>
export type GetAttendeesQueryError = AxiosError<unknown>

export const useGetAttendees = <TError = AxiosError<unknown>>(
  deviceId: string,
    meetingId: string, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getAttendees>>, TError> & { swrKey?: Key, enabled?: boolean }, axios?: AxiosRequestConfig }
) => {
  const {swr: swrOptions, axios: axiosOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && !!(deviceId && meetingId)
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetAttendeesKey(deviceId,meetingId) : null);
  const swrFn = () => getAttendees(deviceId,meetingId, axiosOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export const getRedial = (
    identifier: string,
    params?: GetRedialParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ReceptionCallHistory>> => {
    return axios.get(
      `https://www.suitebook.cloud/api/v1/receptions/${identifier}/redial/`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }



export const getGetRedialKey = (identifier: string,
    params?: GetRedialParams,) => [`https://www.suitebook.cloud/api/v1/receptions/${identifier}/redial/`, ...(params ? [params]: [])] as const;

export type GetRedialQueryResult = NonNullable<Awaited<ReturnType<typeof getRedial>>>
export type GetRedialQueryError = AxiosError<unknown>

export const useGetRedial = <TError = AxiosError<unknown>>(
  identifier: string,
    params?: GetRedialParams, options?: { swr?:SWRConfiguration<Awaited<ReturnType<typeof getRedial>>, TError> & { swrKey?: Key, enabled?: boolean }, axios?: AxiosRequestConfig }
) => {
  const {swr: swrOptions, axios: axiosOptions} = options ?? {}

  const isEnabled = swrOptions?.enabled !== false && !!(identifier)
  const swrKey = swrOptions?.swrKey ?? (() => isEnabled ? getGetRedialKey(identifier,params) : null);
  const swrFn = () => getRedial(identifier,params, axiosOptions)

  const query = useSwr<Awaited<ReturnType<typeof swrFn>>, TError>(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export const updateReceptionCallHistoryByTaskSid = (
    identifier: string,
    taskSid: string,
    receptionCallHistory: NonReadonly<ReceptionCallHistory>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ReceptionCallHistory>> => {
    return axios.put(
      `https://www.suitebook.cloud/api/v1/receptions/${identifier}/histories/task-sid/${taskSid}/`,
      receptionCallHistory,options
    );
  }



export const getUpdateReceptionCallHistoryByTaskSidMutationFetcher = (identifier: string,
    taskSid: string, options?: AxiosRequestConfig) => {
  return (_: Key, { arg }: { arg: NonReadonly<ReceptionCallHistory> }): Promise<AxiosResponse<ReceptionCallHistory>> => {
    return updateReceptionCallHistoryByTaskSid(identifier, taskSid, arg, options);
  }
}
export const getUpdateReceptionCallHistoryByTaskSidMutationKey = (identifier: string,
    taskSid: string,) => [`https://www.suitebook.cloud/api/v1/receptions/${identifier}/histories/task-sid/${taskSid}/`] as const;

export type UpdateReceptionCallHistoryByTaskSidMutationResult = NonNullable<Awaited<ReturnType<typeof updateReceptionCallHistoryByTaskSid>>>
export type UpdateReceptionCallHistoryByTaskSidMutationError = AxiosError<unknown>

export const useUpdateReceptionCallHistoryByTaskSid = <TError = AxiosError<unknown>>(
  identifier: string,
    taskSid: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof updateReceptionCallHistoryByTaskSid>>, TError, Key, NonReadonly<ReceptionCallHistory>, Awaited<ReturnType<typeof updateReceptionCallHistoryByTaskSid>>> & { swrKey?: string }, axios?: AxiosRequestConfig}
) => {

  const {swr: swrOptions, axios: axiosOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getUpdateReceptionCallHistoryByTaskSidMutationKey(identifier,taskSid);
  const swrFn = getUpdateReceptionCallHistoryByTaskSidMutationFetcher(identifier,taskSid, axiosOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export const patchReceptionCallHistoryByTaskSid = (
    identifier: string,
    taskSid: string,
    receptionCallHistory: NonReadonly<ReceptionCallHistory>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ReceptionCallHistory>> => {
    return axios.patch(
      `https://www.suitebook.cloud/api/v1/receptions/${identifier}/histories/task-sid/${taskSid}/`,
      receptionCallHistory,options
    );
  }



export const getPatchReceptionCallHistoryByTaskSidMutationFetcher = (identifier: string,
    taskSid: string, options?: AxiosRequestConfig) => {
  return (_: Key, { arg }: { arg: NonReadonly<ReceptionCallHistory> }): Promise<AxiosResponse<ReceptionCallHistory>> => {
    return patchReceptionCallHistoryByTaskSid(identifier, taskSid, arg, options);
  }
}
export const getPatchReceptionCallHistoryByTaskSidMutationKey = (identifier: string,
    taskSid: string,) => [`https://www.suitebook.cloud/api/v1/receptions/${identifier}/histories/task-sid/${taskSid}/`] as const;

export type PatchReceptionCallHistoryByTaskSidMutationResult = NonNullable<Awaited<ReturnType<typeof patchReceptionCallHistoryByTaskSid>>>
export type PatchReceptionCallHistoryByTaskSidMutationError = AxiosError<unknown>

export const usePatchReceptionCallHistoryByTaskSid = <TError = AxiosError<unknown>>(
  identifier: string,
    taskSid: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof patchReceptionCallHistoryByTaskSid>>, TError, Key, NonReadonly<ReceptionCallHistory>, Awaited<ReturnType<typeof patchReceptionCallHistoryByTaskSid>>> & { swrKey?: string }, axios?: AxiosRequestConfig}
) => {

  const {swr: swrOptions, axios: axiosOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPatchReceptionCallHistoryByTaskSidMutationKey(identifier,taskSid);
  const swrFn = getPatchReceptionCallHistoryByTaskSidMutationFetcher(identifier,taskSid, axiosOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export const updateReceptionCallHistoryByMeetingId = (
    identifier: string,
    meetingId: string,
    receptionCallHistory: NonReadonly<ReceptionCallHistory>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ReceptionCallHistory>> => {
    return axios.put(
      `https://www.suitebook.cloud/api/v1/receptions/${identifier}/histories/meeting-id/${meetingId}/`,
      receptionCallHistory,options
    );
  }



export const getUpdateReceptionCallHistoryByMeetingIdMutationFetcher = (identifier: string,
    meetingId: string, options?: AxiosRequestConfig) => {
  return (_: Key, { arg }: { arg: NonReadonly<ReceptionCallHistory> }): Promise<AxiosResponse<ReceptionCallHistory>> => {
    return updateReceptionCallHistoryByMeetingId(identifier, meetingId, arg, options);
  }
}
export const getUpdateReceptionCallHistoryByMeetingIdMutationKey = (identifier: string,
    meetingId: string,) => [`https://www.suitebook.cloud/api/v1/receptions/${identifier}/histories/meeting-id/${meetingId}/`] as const;

export type UpdateReceptionCallHistoryByMeetingIdMutationResult = NonNullable<Awaited<ReturnType<typeof updateReceptionCallHistoryByMeetingId>>>
export type UpdateReceptionCallHistoryByMeetingIdMutationError = AxiosError<unknown>

export const useUpdateReceptionCallHistoryByMeetingId = <TError = AxiosError<unknown>>(
  identifier: string,
    meetingId: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof updateReceptionCallHistoryByMeetingId>>, TError, Key, NonReadonly<ReceptionCallHistory>, Awaited<ReturnType<typeof updateReceptionCallHistoryByMeetingId>>> & { swrKey?: string }, axios?: AxiosRequestConfig}
) => {

  const {swr: swrOptions, axios: axiosOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getUpdateReceptionCallHistoryByMeetingIdMutationKey(identifier,meetingId);
  const swrFn = getUpdateReceptionCallHistoryByMeetingIdMutationFetcher(identifier,meetingId, axiosOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}

export const patchReceptionCallHistoryByMeetingId = (
    identifier: string,
    meetingId: string,
    receptionCallHistory: NonReadonly<ReceptionCallHistory>, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ReceptionCallHistory>> => {
    return axios.patch(
      `https://www.suitebook.cloud/api/v1/receptions/${identifier}/histories/meeting-id/${meetingId}/`,
      receptionCallHistory,options
    );
  }



export const getPatchReceptionCallHistoryByMeetingIdMutationFetcher = (identifier: string,
    meetingId: string, options?: AxiosRequestConfig) => {
  return (_: Key, { arg }: { arg: NonReadonly<ReceptionCallHistory> }): Promise<AxiosResponse<ReceptionCallHistory>> => {
    return patchReceptionCallHistoryByMeetingId(identifier, meetingId, arg, options);
  }
}
export const getPatchReceptionCallHistoryByMeetingIdMutationKey = (identifier: string,
    meetingId: string,) => [`https://www.suitebook.cloud/api/v1/receptions/${identifier}/histories/meeting-id/${meetingId}/`] as const;

export type PatchReceptionCallHistoryByMeetingIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchReceptionCallHistoryByMeetingId>>>
export type PatchReceptionCallHistoryByMeetingIdMutationError = AxiosError<unknown>

export const usePatchReceptionCallHistoryByMeetingId = <TError = AxiosError<unknown>>(
  identifier: string,
    meetingId: string, options?: { swr?:SWRMutationConfiguration<Awaited<ReturnType<typeof patchReceptionCallHistoryByMeetingId>>, TError, Key, NonReadonly<ReceptionCallHistory>, Awaited<ReturnType<typeof patchReceptionCallHistoryByMeetingId>>> & { swrKey?: string }, axios?: AxiosRequestConfig}
) => {

  const {swr: swrOptions, axios: axiosOptions} = options ?? {}

  const swrKey = swrOptions?.swrKey ?? getPatchReceptionCallHistoryByMeetingIdMutationKey(identifier,meetingId);
  const swrFn = getPatchReceptionCallHistoryByMeetingIdMutationFetcher(identifier,meetingId, axiosOptions);

  const query = useSWRMutation(swrKey, swrFn, swrOptions)

  return {
    swrKey,
    ...query
  }
}



export const getCreateTaskResponseMock = (overrideResponse: Partial< CreateTaskResponse > = {}): CreateTaskResponse => ({task_sid: faker.helpers.arrayElement([faker.word.sample(), undefined]), ...overrideResponse})

export const getGetTaskMeetingResponseMock = (overrideResponse: Partial< MeetingResponse > = {}): MeetingResponse => ({Attendees: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({AttendeeId: faker.helpers.arrayElement([faker.string.uuid(), undefined]), Capabilities: faker.helpers.arrayElement([{Audio: faker.helpers.arrayElement([faker.word.sample(), undefined]), Content: faker.helpers.arrayElement([faker.word.sample(), undefined]), Video: faker.helpers.arrayElement([faker.word.sample(), undefined])}, undefined]), ExternalUserId: faker.helpers.arrayElement([faker.word.sample(), undefined]), JoinToken: faker.helpers.arrayElement([faker.word.sample(), undefined])})), undefined]), deviceId: faker.helpers.arrayElement([faker.word.sample(), undefined]), Errors: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.word.sample())), undefined]), guestConnectionStartTime: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), language: faker.helpers.arrayElement([faker.word.sample(), undefined]), Meeting: faker.helpers.arrayElement([{ExternalMeetingId: faker.helpers.arrayElement([faker.word.sample(), undefined]), MediaPlacement: faker.helpers.arrayElement([{AudioFallbackUrl: faker.helpers.arrayElement([faker.internet.url(), undefined]), AudioHostUrl: faker.helpers.arrayElement([faker.word.sample(), undefined]), EventIngestionUrl: faker.helpers.arrayElement([faker.internet.url(), undefined]), ScreenDataUrl: faker.helpers.arrayElement([faker.internet.url(), undefined]), ScreenSharingUrl: faker.helpers.arrayElement([faker.internet.url(), undefined]), ScreenViewingUrl: faker.helpers.arrayElement([faker.internet.url(), undefined]), SignalingUrl: faker.helpers.arrayElement([faker.internet.url(), undefined]), TurnControlUrl: faker.helpers.arrayElement([faker.internet.url(), undefined])}, undefined]), MediaRegion: faker.helpers.arrayElement([faker.word.sample(), undefined]), MeetingArn: faker.helpers.arrayElement([faker.word.sample(), undefined]), MeetingFeatures: faker.helpers.arrayElement([{}, undefined]), MeetingHostId: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.word.sample(), null]), undefined]), MeetingId: faker.helpers.arrayElement([faker.word.sample(), undefined]), PrimaryMeetingId: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.word.sample(), null]), undefined]), TenantIds: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.word.sample())), undefined])}, undefined]), propertySlug: faker.helpers.arrayElement([faker.word.sample(), undefined]), requirement: faker.helpers.arrayElement([faker.word.sample(), undefined]), ...overrideResponse})

export const getGetReceptionDeviceResponseMock = (overrideResponse: Partial< ReceptionDevice > = {}): ReceptionDevice => ({automated_communication_system: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), call_system: faker.helpers.arrayElement([faker.word.sample(), undefined]), id: faker.helpers.arrayElement([faker.word.sample(), undefined]), organization_slug: faker.helpers.arrayElement([faker.word.sample(), undefined]), property_id: faker.helpers.arrayElement([faker.word.sample(), undefined]), property_slug: faker.helpers.arrayElement([faker.word.sample(), undefined]), property_translations: faker.helpers.arrayElement([{en: faker.helpers.arrayElement([{name: faker.helpers.arrayElement([faker.word.sample(), undefined])}, undefined]), ja: faker.helpers.arrayElement([{name: faker.helpers.arrayElement([faker.word.sample(), undefined])}, undefined])}, undefined]), translations: faker.helpers.arrayElement([{en: faker.helpers.arrayElement([{description: faker.helpers.arrayElement([faker.word.sample(), undefined]), name: faker.helpers.arrayElement([faker.word.sample(), undefined])}, undefined]), ja: faker.helpers.arrayElement([{description: faker.helpers.arrayElement([faker.word.sample(), undefined]), name: faker.helpers.arrayElement([faker.word.sample(), undefined])}, undefined])}, undefined]), ...overrideResponse})

export const getUpdateTaskStatusResponseMock = (): UpdateTaskStatus200 => ({})

export const getGetDeviceMeetingResponseMock = (overrideResponse: Partial< MeetingResponse > = {}): MeetingResponse => ({Attendees: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({AttendeeId: faker.helpers.arrayElement([faker.string.uuid(), undefined]), Capabilities: faker.helpers.arrayElement([{Audio: faker.helpers.arrayElement([faker.word.sample(), undefined]), Content: faker.helpers.arrayElement([faker.word.sample(), undefined]), Video: faker.helpers.arrayElement([faker.word.sample(), undefined])}, undefined]), ExternalUserId: faker.helpers.arrayElement([faker.word.sample(), undefined]), JoinToken: faker.helpers.arrayElement([faker.word.sample(), undefined])})), undefined]), deviceId: faker.helpers.arrayElement([faker.word.sample(), undefined]), Errors: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.word.sample())), undefined]), guestConnectionStartTime: faker.helpers.arrayElement([faker.number.int({min: undefined, max: undefined}), undefined]), language: faker.helpers.arrayElement([faker.word.sample(), undefined]), Meeting: faker.helpers.arrayElement([{ExternalMeetingId: faker.helpers.arrayElement([faker.word.sample(), undefined]), MediaPlacement: faker.helpers.arrayElement([{AudioFallbackUrl: faker.helpers.arrayElement([faker.internet.url(), undefined]), AudioHostUrl: faker.helpers.arrayElement([faker.word.sample(), undefined]), EventIngestionUrl: faker.helpers.arrayElement([faker.internet.url(), undefined]), ScreenDataUrl: faker.helpers.arrayElement([faker.internet.url(), undefined]), ScreenSharingUrl: faker.helpers.arrayElement([faker.internet.url(), undefined]), ScreenViewingUrl: faker.helpers.arrayElement([faker.internet.url(), undefined]), SignalingUrl: faker.helpers.arrayElement([faker.internet.url(), undefined]), TurnControlUrl: faker.helpers.arrayElement([faker.internet.url(), undefined])}, undefined]), MediaRegion: faker.helpers.arrayElement([faker.word.sample(), undefined]), MeetingArn: faker.helpers.arrayElement([faker.word.sample(), undefined]), MeetingFeatures: faker.helpers.arrayElement([{}, undefined]), MeetingHostId: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.word.sample(), null]), undefined]), MeetingId: faker.helpers.arrayElement([faker.word.sample(), undefined]), PrimaryMeetingId: faker.helpers.arrayElement([faker.helpers.arrayElement([faker.word.sample(), null]), undefined]), TenantIds: faker.helpers.arrayElement([Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => (faker.word.sample())), undefined])}, undefined]), propertySlug: faker.helpers.arrayElement([faker.word.sample(), undefined]), requirement: faker.helpers.arrayElement([faker.word.sample(), undefined]), ...overrideResponse})

export const getGetAttendeesResponseMock = (overrideResponse: Partial< AttendeeResponses > = {}): AttendeeResponses => ({Attendees: Array.from({ length: faker.number.int({ min: 1, max: 10 }) }, (_, i) => i + 1).map(() => ({AttendeeId: faker.helpers.arrayElement([faker.string.uuid(), undefined]), Capabilities: faker.helpers.arrayElement([{Audio: faker.helpers.arrayElement([faker.word.sample(), undefined]), Content: faker.helpers.arrayElement([faker.word.sample(), undefined]), Video: faker.helpers.arrayElement([faker.word.sample(), undefined])}, undefined]), ExternalUserId: faker.helpers.arrayElement([faker.word.sample(), undefined]), JoinToken: faker.helpers.arrayElement([faker.word.sample(), undefined])})), ...overrideResponse})

export const getGetRedialResponseMock = (overrideResponse: Partial< ReceptionCallHistory > = {}): ReceptionCallHistory => ({call_type: faker.helpers.arrayElement([faker.helpers.arrayElement(['call_from_device','redial_from_reception'] as const), undefined]), caller_status: faker.helpers.arrayElement([faker.helpers.arrayElement([1,2,3,4,5] as const), undefined]), canceled: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), established: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), finished: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), meeting_id: faker.helpers.arrayElement([faker.word.sample(), undefined]), received: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), receiver_status: faker.helpers.arrayElement([faker.helpers.arrayElement([1,2,3,4,5] as const), undefined]), reception_device_id: faker.helpers.arrayElement([faker.word.sample(), undefined]), rejected: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), task_sid: faker.helpers.arrayElement([faker.word.sample(), undefined]), timeouted: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), ...overrideResponse})

export const getUpdateReceptionCallHistoryByTaskSidResponseMock = (overrideResponse: Partial< ReceptionCallHistory > = {}): ReceptionCallHistory => ({call_type: faker.helpers.arrayElement([faker.helpers.arrayElement(['call_from_device','redial_from_reception'] as const), undefined]), caller_status: faker.helpers.arrayElement([faker.helpers.arrayElement([1,2,3,4,5] as const), undefined]), canceled: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), established: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), finished: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), meeting_id: faker.helpers.arrayElement([faker.word.sample(), undefined]), received: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), receiver_status: faker.helpers.arrayElement([faker.helpers.arrayElement([1,2,3,4,5] as const), undefined]), reception_device_id: faker.helpers.arrayElement([faker.word.sample(), undefined]), rejected: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), task_sid: faker.helpers.arrayElement([faker.word.sample(), undefined]), timeouted: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), ...overrideResponse})

export const getPatchReceptionCallHistoryByTaskSidResponseMock = (overrideResponse: Partial< ReceptionCallHistory > = {}): ReceptionCallHistory => ({call_type: faker.helpers.arrayElement([faker.helpers.arrayElement(['call_from_device','redial_from_reception'] as const), undefined]), caller_status: faker.helpers.arrayElement([faker.helpers.arrayElement([1,2,3,4,5] as const), undefined]), canceled: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), established: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), finished: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), meeting_id: faker.helpers.arrayElement([faker.word.sample(), undefined]), received: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), receiver_status: faker.helpers.arrayElement([faker.helpers.arrayElement([1,2,3,4,5] as const), undefined]), reception_device_id: faker.helpers.arrayElement([faker.word.sample(), undefined]), rejected: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), task_sid: faker.helpers.arrayElement([faker.word.sample(), undefined]), timeouted: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), ...overrideResponse})

export const getUpdateReceptionCallHistoryByMeetingIdResponseMock = (overrideResponse: Partial< ReceptionCallHistory > = {}): ReceptionCallHistory => ({call_type: faker.helpers.arrayElement([faker.helpers.arrayElement(['call_from_device','redial_from_reception'] as const), undefined]), caller_status: faker.helpers.arrayElement([faker.helpers.arrayElement([1,2,3,4,5] as const), undefined]), canceled: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), established: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), finished: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), meeting_id: faker.helpers.arrayElement([faker.word.sample(), undefined]), received: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), receiver_status: faker.helpers.arrayElement([faker.helpers.arrayElement([1,2,3,4,5] as const), undefined]), reception_device_id: faker.helpers.arrayElement([faker.word.sample(), undefined]), rejected: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), task_sid: faker.helpers.arrayElement([faker.word.sample(), undefined]), timeouted: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), ...overrideResponse})

export const getPatchReceptionCallHistoryByMeetingIdResponseMock = (overrideResponse: Partial< ReceptionCallHistory > = {}): ReceptionCallHistory => ({call_type: faker.helpers.arrayElement([faker.helpers.arrayElement(['call_from_device','redial_from_reception'] as const), undefined]), caller_status: faker.helpers.arrayElement([faker.helpers.arrayElement([1,2,3,4,5] as const), undefined]), canceled: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), established: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), finished: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), meeting_id: faker.helpers.arrayElement([faker.word.sample(), undefined]), received: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), receiver_status: faker.helpers.arrayElement([faker.helpers.arrayElement([1,2,3,4,5] as const), undefined]), reception_device_id: faker.helpers.arrayElement([faker.word.sample(), undefined]), rejected: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), task_sid: faker.helpers.arrayElement([faker.word.sample(), undefined]), timeouted: faker.helpers.arrayElement([`${faker.date.past().toISOString().split('.')[0]}Z`, undefined]), ...overrideResponse})


export const getCreateTaskMockHandler = (overrideResponse?: CreateTaskResponse | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<CreateTaskResponse> | CreateTaskResponse)) => {
  return http.post('*/api/v1/receptions/:deviceId/create-task/', async (info) => {await delay(1000);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getCreateTaskResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getGetTaskMeetingMockHandler = (overrideResponse?: MeetingResponse | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<MeetingResponse> | MeetingResponse)) => {
  return http.get('*/api/v1/receptions/meeting/:taskSid/', async (info) => {await delay(1000);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getGetTaskMeetingResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getGetReceptionDeviceMockHandler = (overrideResponse?: ReceptionDevice | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<ReceptionDevice> | ReceptionDevice)) => {
  return http.get('*/api/v1/receptions/:deviceId/', async (info) => {await delay(1000);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getGetReceptionDeviceResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getUpdateTaskStatusMockHandler = (overrideResponse?: UpdateTaskStatus200 | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<UpdateTaskStatus200> | UpdateTaskStatus200)) => {
  return http.patch('*/api/v1/receptions/:deviceId/task-status/', async (info) => {await delay(1000);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getUpdateTaskStatusResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getGetDeviceMeetingMockHandler = (overrideResponse?: MeetingResponse | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<MeetingResponse> | MeetingResponse)) => {
  return http.get('*/api/v1/receptions/:deviceId/meetings/:meetingId/', async (info) => {await delay(1000);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getGetDeviceMeetingResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getGetAttendeesMockHandler = (overrideResponse?: AttendeeResponses | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<AttendeeResponses> | AttendeeResponses)) => {
  return http.get('*/api/v1/receptions/:deviceId/attendees/:meetingId/', async (info) => {await delay(1000);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getGetAttendeesResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getGetRedialMockHandler = (overrideResponse?: ReceptionCallHistory | ((info: Parameters<Parameters<typeof http.get>[1]>[0]) => Promise<ReceptionCallHistory> | ReceptionCallHistory)) => {
  return http.get('*/api/v1/receptions/:identifier/redial/', async (info) => {await delay(1000);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getGetRedialResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getUpdateReceptionCallHistoryByTaskSidMockHandler = (overrideResponse?: ReceptionCallHistory | ((info: Parameters<Parameters<typeof http.put>[1]>[0]) => Promise<ReceptionCallHistory> | ReceptionCallHistory)) => {
  return http.put('*/api/v1/receptions/:identifier/histories/task-sid/:taskSid/', async (info) => {await delay(1000);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getUpdateReceptionCallHistoryByTaskSidResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPatchReceptionCallHistoryByTaskSidMockHandler = (overrideResponse?: ReceptionCallHistory | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<ReceptionCallHistory> | ReceptionCallHistory)) => {
  return http.patch('*/api/v1/receptions/:identifier/histories/task-sid/:taskSid/', async (info) => {await delay(1000);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPatchReceptionCallHistoryByTaskSidResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getUpdateReceptionCallHistoryByMeetingIdMockHandler = (overrideResponse?: ReceptionCallHistory | ((info: Parameters<Parameters<typeof http.put>[1]>[0]) => Promise<ReceptionCallHistory> | ReceptionCallHistory)) => {
  return http.put('*/api/v1/receptions/:identifier/histories/meeting-id/:meetingId/', async (info) => {await delay(1000);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getUpdateReceptionCallHistoryByMeetingIdResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}

export const getPatchReceptionCallHistoryByMeetingIdMockHandler = (overrideResponse?: ReceptionCallHistory | ((info: Parameters<Parameters<typeof http.patch>[1]>[0]) => Promise<ReceptionCallHistory> | ReceptionCallHistory)) => {
  return http.patch('*/api/v1/receptions/:identifier/histories/meeting-id/:meetingId/', async (info) => {await delay(1000);
  
    return new HttpResponse(JSON.stringify(overrideResponse !== undefined 
            ? (typeof overrideResponse === "function" ? await overrideResponse(info) : overrideResponse) 
            : getPatchReceptionCallHistoryByMeetingIdResponseMock()),
      { status: 200,
        headers: { 'Content-Type': 'application/json' }
      })
  })
}
export const getAosWwwApiMock = () => [
  getCreateTaskMockHandler(),
  getGetTaskMeetingMockHandler(),
  getGetReceptionDeviceMockHandler(),
  getUpdateTaskStatusMockHandler(),
  getGetDeviceMeetingMockHandler(),
  getGetAttendeesMockHandler(),
  getGetRedialMockHandler(),
  getUpdateReceptionCallHistoryByTaskSidMockHandler(),
  getPatchReceptionCallHistoryByTaskSidMockHandler(),
  getUpdateReceptionCallHistoryByMeetingIdMockHandler(),
  getPatchReceptionCallHistoryByMeetingIdMockHandler()
]
